import React, { useState } from 'react';
import { Button } from 'reactstrap';
import AddNewMessenger from './AddNewMessenger';

export default function MessengerFormButton({
    id, isHostedPage, isServiceOrder, allAddonCategoryData, allMembershipGroupData, LoadData, languageCode, productCategorydata
}) {
    const [isUpdating, setIsUpdating] = useState(false);

    return (
        <div>
            <Button
                color="primary"
                size="xs"
                onClick={() => setIsUpdating(!isUpdating)}
            >
                Edit
            </Button>
            {isUpdating && (
                <AddNewMessenger
                    id={id}
                    toggleModal={() => {
                        setIsUpdating(!isUpdating);
                    }}
                    formLabel="Edit"
                    visible={isUpdating}
                    isHostedPage={isHostedPage}
                    isServiceOrder={isServiceOrder}
                    allAddonCategoryData={allAddonCategoryData}
                    allMembershipGroupData={allMembershipGroupData}
                    LoadData={LoadData}
                    languageCode={languageCode}
                    productCategorydata={productCategorydata}
                />
            )}
        </div>
    );
}

